import type { ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Icon } from '../components/installer/icons.js'
import { useStep } from '../state/useStep.js'

export const StartScreen = (): ReactElement => {
  const { goto } = useStep()

  return (
    <AppShell title="Installation &amp; verification">
      {/* installer-surface must be an ANCESTOR of .start-container (rules are
          descendant-scoped), else the centering/height never applies. */}
      <div className="installer-surface" style={{ height: '100%' }}>
        <div className="start-container">
          <div className="start-card fade-in">
            <div className="shield-icon">
              <Icon.Shield size={32} />
            </div>
            <div className="start-eyebrow">VERITACT · INSTALL VERIFICATION</div>
            <div className="start-title">Installation &amp; verification</div>
            <button className="start-btn" onClick={() => goto('job-brief')}>
              Start
            </button>
          </div>
        </div>
      </div>
    </AppShell>
  )
}
